<template>
  <div class="no-teacher-status">
    <img
      class="icon-consult ic-no-order"
      src="../../images/consult/expertList/teacher-nomore.png"
    />
    <slot name="blank-txt">
      <p class="blank-txt" v-html="text"></p>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: `没有找到对应咨询师`
    }
  }
}
</script>

<style lang="scss">
.no-teacher-status {
  padding-top: 100px;
  .icon-consult {
    display: block;
    margin: 0 auto;
    width: 300px;
    background-size: 100%;
  }
  .blank-txt {
    text-align: center;
    margin-top: 20px;
    font-size: 26px;
    color: #666;
    line-height: 38px;
  }
}
</style>
